import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export type Profile = {
  id: string;
  role: 'admin' | 'organizer' | 'accounts' | 'participant';
  full_name: string | null;
  email: string | null;
  email_verified: boolean | null;
  created_at: string;
  updated_at: string;
  account_status?: string | null;
  failed_login_attempts?: number | null;
  last_failed_login?: string | null;
  locked_by?: string | null;
  locked_at?: string | null;
  unlocked_by?: string | null;
  unlocked_at?: string | null;
};